import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function StatusBtn({ onStatusChange }) {
  const { t } = useTranslation();
  const [activeBtn, setActiveBtn] = useState("All");

  const handleClick = (status) => {
    setActiveBtn(status);
    onStatusChange(status);
  };

  const tabs = [
    { id: "All",            label: t("All")             },
    { id: "Preproduction",  label: t("Pre-Production")  },
    { id: "Production",     label: t("Production")      },
    { id: "Postproduction", label: t("Post-Production") },
  ];

  return (
    <div className="tw-flex tw-rounded-xl tw-bg-white/10 tw-p-1 tw-gap-1">
      {tabs.map(({ id, label }) => (
        <button
          key={id}
          onClick={() => handleClick(id)}
          className={`tw-px-2 sm:tw-px-5 tw-py-2 tw-rounded-lg tw-text-xs sm:tw-text-sm tw-font-semibold tw-transition-colors tw-border-0 tw-cursor-pointer tw-whitespace-nowrap ${
            activeBtn === id
              ? "tw-bg-[#712CB0] tw-text-white"
              : "tw-bg-transparent tw-text-white/60 hover:tw-text-white"
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
